// src/features/owner/OwnerTopbar.tsx — owner page header: title + Owner Panel badge + (date range + export slots).
import styled from 'styled-components';
import type { ReactNode } from 'react';
import { Icon } from '@/icons';

const Bar = styled.header` display:flex; align-items:center; justify-content:space-between; gap:12px; padding:18px 24px; `;
const Left = styled.div` display:flex; align-items:center; gap:10px; `;
const Title = styled.h1`
  margin:0; font-family:${({ theme }) => theme.font.display};
  font-size:${({ theme }) => theme.fontSize.xl}; color:${({ theme }) => theme.color.textPrimary};
`;
const Badge = styled.span`
  display:inline-flex; align-items:center; gap:5px; font-size:${({ theme }) => theme.fontSize.xs};
  font-weight:600; color:${({ theme }) => theme.color.brandFrom};
  background:${({ theme }) => theme.color.glassBg};
  border:1px solid ${({ theme }) => theme.color.glassBorder}; border-radius: ${({ theme }) => theme.radius.sm}; padding:3px 10px;
`;
const Right = styled.div` display:flex; align-items:center; gap:8px; `;

export function OwnerTopbar({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <Bar>
      <Left><Title>{title}</Title><Badge><Icon name="shield" size={12} /> Owner Panel</Badge></Left>
      <Right>{actions}</Right>
    </Bar>
  );
}
